import { createFileRoute } from "@tanstack/react-router";
import { SharingPage } from "@/modules/sharing/presentation/pages/SharingPage";

export const Route = createFileRoute("/_authenticated/sharing")({
  component: SharingPage,
});
